import {getCarTitle} from './car.service';
import {
	OfferModel,
	OFFER_TYPE,
	LeaseOffer,
	FinanceOffer,
	CashOffer,
	SUB_CATEGORY,
	MsrpOffer,
} from '../models/offer.model';
import {OEM} from '../models/oem.enum';

export const convertOffers = (offers: Record<string, any>[]): OfferModel[] => {
	return offers.map((offer: Record<string, any>): OfferModel => {
		let offerPayload = {
			...offer,
			car_title: getCarTitle(offer),
		} as OfferModel;

		if (offer.category === OFFER_TYPE.LEASE) {
			offerPayload = {
				...offerPayload,
				lease_amount_per_month: (+(offer.lease_amount_per_month))?.toLocaleString(),
				lease_months: (+offer.lease_months)?.toLocaleString(),
				lease_due_at_signing: (+offer.lease_due_at_signing)?.toLocaleString(),
			} as LeaseOffer;

			if (offer.lease_down_payment) {
				offerPayload.lease_down_payment = (+offer.lease_down_payment)?.toLocaleString();
			}

			if (offer.security_deposit) {
				offerPayload.security_deposit = (+offer.security_deposit)?.toLocaleString();
			}
		}

		if (offer.category === OFFER_TYPE.FINANCE) {
			offerPayload = {
				...offerPayload,
				finance_apr: (+(offer.finance_apr))?.toLocaleString(),
				finance_months: (+offer.finance_months)?.toLocaleString(),
			} as FinanceOffer;
			if (offer.finance_amount_per_month) {
				offerPayload.finance_amount_per_month = (+offer.finance_amount_per_month)?.toLocaleString();
			}
			if (offer.finance_down_payment) {
				offerPayload.finance_down_payment = (+offer.finance_down_payment)?.toLocaleString();
			}
		}

		if (offer.category === OFFER_TYPE.CASH) {
			offerPayload = {
				...offerPayload,
				cash_amount: (+(offer.cash_amount))?.toLocaleString(),
			} as CashOffer;
		}

		if (offer.category === OFFER_TYPE.OFF_MSRP) {
			offerPayload = {
				...offerPayload,
				off_amount: (+(offer.off_amount))?.toLocaleString(),
			} as MsrpOffer;
		}

		return offerPayload;
	});
};

export const getCashBackWording = (offer: CashOffer): string => {
	const baseText = offer?.car_make?.toLowerCase() === OEM.NISSAN ? 'Nissan ' : '';
	if (offer?.sub_category?.toLowerCase() === SUB_CATEGORY.TOTAL_SAVINGS) {
		return `${baseText}${SUB_CATEGORY.TOTAL_SAVINGS}`;
	}
	return `${baseText} cash back`;
};
